<template>
  <Tooltip
    :content="contentVal"
    :placement="placementVal"
    :delay="delayVal"
    :theme="themeVal"
    :max-width="maxWidthVal"
    :transfer="transferVal"
  >
    <Icon :type="iconNameVal" :size="iconSizeVal" :color="iconColorVal" />
  </Tooltip>
</template>
<script>
export default {
  name: 'tblcomponents',
  props: {
    contentVal: {
      type: String,
      default: '提示'
    },
    placementVal: {
      type: String,
      default: 'right'
    },
    delayVal: {
      type: Number,
      default: 100
    },
    themeVal: {
      type: String,
      default: 'dark'
    },
    maxWidthVal: {
      type: String,
      default: '40px'
    },
    transferVal: {
      type: Boolean,
      default: true
    },
    iconNameVal: {
      type: String,
      default: 'ios-arrow-down'
    },
    iconSizeVal: {
      type: Number,
      default: 20
    },
    iconColorVal: {
      type: String,
      default: '#2d8cf0'
    }
  },
  data() {
    return {
      tabelLoading: false
    }
  },
  created() {},
  methods: {
    search(page) {
      this.tabelLoading = true
      this.$emit('search', page)
      this.tabelLoading = false
    }
  }
}
</script>
